import fetch from './ajax'

// 判断测试还是正式环境
const DEBUG =
  !(location.host.indexOf('live-h5.360che.com') > -1)
const ROOT_TEST = 'https://live-test.360che.com/' // 测试地址
const ROOT_LINE = 'https://live.360che.com/' // 正式地址
const MAICHEAPITEST = 'https://maiche-api-test.360che.com/'
const MAICHEAPI = 'https://maiche-api.360che.com/'

const ROOTS = DEBUG ? ROOT_TEST : ROOT_LINE
const MAICHE = DEBUG ? MAICHEAPITEST : MAICHEAPI
// const USER_TEST = 'https://liaoche-api-test.360che.com' // 测试地址
// const LIAOCHE_LINE = 'https://liaoche-api-test.360che.com' // 正式地址
// const USER = DEBUG ? USER_TEST : USER_LINE

const BBSAPI_TEST = 'https://bbs-api-test.360che.com' // 测试地址
const BBSAPI_DEV = 'https://bbs-api.360che.com' // 正式地址
const BBSAPI = DEBUG ? BBSAPI_TEST : BBSAPI_DEV

class XHR {
  // 微信分享SDK
  getWeixin (json) {
    return fetch({
      url: `${BBSAPI}/interface/app/index.php?action=weixin&method=getWxConfig&url=${encodeURIComponent(json.url)}`,
      type: 'get'
    })
  }

  // 获取直播间信息
  getLiveRoom (json) {
    return fetch({
      url: `${ROOTS}live/get-anchor-room`,
      body: json,
      type: 'GET'
    })
  }

  // 获取用户昵称
  getMyInfo (json) {
    return fetch({
      url: `${ROOTS}live/get-user-info`,
      body: json,
      type: 'GET'
    })
  }

  // 关注用户
  followUser (json) {
    return fetch({
      url: `${ROOTS}live/follow`,
      body: json,
      type: 'GET'
    })
  }

  // 获取关注状态
  getFollowStatus (json) {
    return fetch({
      url: `${ROOTS}live/is-follow`,
      body: json,
      type: 'GET'
    })
  }

  // 取消关注
  cancelFollowUser (json) {
    return fetch({
      url: `${ROOTS}live/un-follow`,
      body: json,
      type: 'GET'
    })
  }

  // 回放获得评论列表
  getComment (json) {
    return fetch({
      url: `${ROOTS}live/get-chat-message`,
      body: json,
      type: 'GET'
    })
  }

  // 回放
  comment (json) {
    return fetch({
      url: `${ROOTS}live/chat`,
      body: json,
      type: 'POST'
    })
  }

  // 获取当前时间戳
  getNowTime (json) {
    return fetch({
      url: `${ROOTS}live/get-timestamp`,
      body: json,
      type: 'GET'
    })
  }

  // 获取询底价信息
  getPrice (json) {
    return fetch({
      url: `${ROOTS}room/inquiry-info`,
      body: json,
      type: 'GET'
    })
  }

  // 获取车型列表
  getModelList (json) {
    return fetch({
      url: `${ROOTS}room/client-car`,
      body: json,
      type: 'GET'
    })
  }

  // 获取直播间推广数据
  getPromoteData (json) {
    return fetch({
      url: `${ROOTS}room/get-promote-data`,
      body: json,
      type: 'GET'
    })
  }

  // 获取转盘抽奖设置
  getLotterySetting (json) {
    return fetch({
      url: `${ROOTS}lottery/get-lottery-setting`,
      body: json,
      type: 'GET'
    })
  }

  // 获取留资活动入口信息
  getFormEntryInfo (json) {
    return fetch({
      url: `${ROOTS}form-activity/entry-info`,
      body: json,
      type: 'GET'
    })
  }

  // 获取奖品列表
  getPrizeList (json) {
    return fetch({
      url: `${ROOTS}lottery/prize-list`,
      body: json,
      type: 'GET'
    })
  }

  // 留资表单渲染规则
  getFormRenderRule (json) {
    return fetch({
      url: `${ROOTS}form-activity/render-rule`,
      body: json,
      type: 'GET'
    })
  }

  // 抽奖
  toLottery (json) {
    return fetch({
      url: `${ROOTS}lottery/lottery`,
      body: json,
      type: 'POST'
    })
  }

  // 获取直播间中奖列表
  getMyGoal (json) {
    return fetch({
      url: `${ROOTS}lottery/my-goal`,
      body: json,
      type: 'GET'
    })
  }

  // 获取直播间中奖列表
  getGoalList (json) {
    return fetch({
      url: `${ROOTS}lottery/get-goal-list`,
      body: json,
      type: 'GET'
    })
  }

  // https://topic.360che.com/api/area/getarea.aspx
  getAddress (json) {
    return fetch({
      url: 'https://topic.360che.com/api/area/getarea.aspx',
      body: json,
      type: 'GET'
    })
  }

  formAddData (json) {
    return fetch({
      url: `${ROOTS}form-activity/add-data`,
      body: json,
      type: 'POST'
    })
  }

  getEntryinfo (json) {
    return fetch({
      url: `${ROOTS}/lottery/entry-info`,
      body: json,
      type: 'GET'
    })
  }

  // 进入直播间获取购物车状态以及正在直播的商品信息
  getShoppingConf (json) {
    return fetch({
      url: `${ROOTS}/shopping-cart/shopping-conf`,
      body: json,
      type: 'GET'
    })
  }

  // 获取购物车列表
  getCartList (json) {
    return fetch({
      url: `${ROOTS}/shopping-cart/cart-list`,
      body: json,
      type: 'GET'
    })
  }

  // 获取商品实时库存状态
  getGoodsStatus (json) {
    return fetch({
      url: `${MAICHE}/trilateral/api/v1/frontend/refresh_goods_status`,
      body: json,
      type: 'POST'
    })
  }

  // 获取直播信息
  getLiveInfoNew (json) {
    return fetch({
      url: `${ROOTS}/live/live-info`,
      body: json,
      type: 'GET'
    })
  }
}
const newXHR = new XHR()
const lotteryApi = `${ROOTS}lottery/lottery`
export { newXHR as default, DEBUG, lotteryApi }
